import React, { useEffect, useState } from "react";
import TerminalDatatable from "./TerminalDatatable";
import ViewSettings from "./ViewSettings";
import { useHistory, useLocation } from "react-router-dom";
import TerminalCreatePage from "./TerminalCreatePage";
import TerminalEditPage from "./TerminalEditPage";

function TerminalTabs(props) {
    const [activeTab, setActiveTab] = useState(1);
    const [path, setPath] = useState();
    const history = useHistory();
    const location = useLocation();
    const tabs = [
        {
            name: "Terminal Management",
            path: "/termManagement",
        },
        {
            name: "View Settings",
            path: "/termManagement/view-settings",
        },
        {
            name: "New Terminal",
            path: "/termManagement/new-terminal",
        },
        {
            name: "Edit Terminal",
            path: "/termManagement/edit-terminal",
        },
    ];
    useEffect(() => {
        setPath(location.pathname);
    }, [location.pathname]);

    const renderTab = () => {
        if (path === "/termManagement") {
            return <TerminalDatatable />;
        } else if (path === "/termManagement/view-settings") {
            return <ViewSettings />;
        } else if (path === "/termManagement/new-terminal") {
            return <TerminalCreatePage/>;
        } else if (path === "/termManagement/edit-terminal") {
            return <TerminalEditPage terminalsData={props.terminalsData}/>;
        }
    }

    return (
        <>
            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                {tabs.map((tab, index) => (
                    <li className="nav-item">
                        <a
                            className={`nav-link ${path === tab.path && "active"}`}
                            data-toggle="tab"
                            href="#tb_terminal_mgmt"
                            role="tab"
                            onClick={() => history.push(`${tab.path}`)}
                        >
              <span className="d-block d-sm-none">
                <i className="fas fa-address-card"></i>
              </span>
                            <span
                                className="d-none d-sm-block"
                                style={{ whiteSpace: "pre-line" }}
                            >
                {tab.name}
              </span>
                        </a>
                    </li>
                ))}
            </ul>
            <div className="tab-pane" role="tabpanel">
                {renderTab()}
            </div>
        </>
    );
}

export default TerminalTabs;
